import _ from 'lodash'
import {parse} from './peg-xml'
import type {PartialComponentExport} from '../constants'
import type {XmlAst, XmlAttributes, XmlElement, XmlFile} from './constants'
import {ReportableError} from '@wix/document-manager-utils'
import type {ComponentExportStructure, WmlFileContent} from '@wix/document-services-types'

const deserializeAttributes = (attributes: XmlAttributes): Record<string, any> =>
    _.mapValues(attributes, attribute => {
        try {
            return JSON.parse(attribute)
        } catch {
            return attribute
        }
    })

const parseXmlElement = (
    xmlElement: XmlElement,
    components: PartialComponentExport['structure']['components']
): string => {
    const {tag, attributes, children} = xmlElement

    const component: ComponentExportStructure = {
        ...deserializeAttributes(attributes),
        type: tag,
        components: []
    }

    const componentId = component.id
    if (!componentId) {
        throw new ReportableError({
            errorType: 'IMPORT_WML_ERROR',
            message: 'Component does not have an id'
        })
    }

    for (const child of children) {
        const {type} = child
        if (type === 'element') {
            component.components.push(parseXmlElement(child, components))
        } else if (type === 'text') {
            component.label = child.value
        } else if (type === 'cdata') {
            component.text = child.value
        }
    }

    components[componentId] = component

    return componentId
}

export const parseXmlAst = (xmlAst: XmlAst): PartialComponentExport['structure'] => {
    const components = {}
    const rootComponent = parseXmlElement(xmlAst, components)

    return {
        rootComponent,
        components
    }
}

export const parseXmlToAst = (xmlFile: WmlFileContent): XmlAst => parse(xmlFile, {})

export const parseXmlFile = ({content}: XmlFile): PartialComponentExport['structure'] =>
    parseXmlAst(parseXmlToAst(content))
